export interface IPNSCustodialOrganization {
  id?: string;
  updatedBy?: string;
  name: string;
}
